import { HOUSEHOLD_AT_CONSTANTS, HOUSEHOLD_STEPS } from '@flows/configs/householdAt/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_HouseholdV1GetsafeAt } from '@flows/insurance/schemas'

const household_at_furnishing_level = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('furnishing_level')]:
        BaseSchema_HouseholdV1GetsafeAt.shape.furnishing_level,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_householdAt:steps.furnishing_level.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('furnishing_level'),
        options: HOUSEHOLD_AT_CONSTANTS.furnishing_options.map((option) => {
          return {
            label: {
              type: 'translatableText',
              translationKey: `sharedFlows_householdAt:steps.furnishing_level.bodyTypes.${option}.title`,
            },
            subtitle: {
              type: 'translatableText',
              translationKey: `sharedFlows_householdAt:steps.furnishing_level.bodyTypes.${option}.text`,
            },
            value: option,
          }
        }),
      },
      {
        type: 'infoBox',
        showInfoIcon: true,
        contentSpaceSize: 'none',
        contentConfiguration: [
          {
            type: 'title',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_householdAt:steps.furnishing_level.infoTitle',
            },
          },
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_householdAt:steps.furnishing_level.infoSubtitle',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStep: HOUSEHOLD_STEPS.household_at_cohabitation_type,
  }) as const satisfies AnyStepConfiguration

export default household_at_furnishing_level
